import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";

// const BASE_File_URL = "http://localhost:8082/gateway/finance/File"

// const BASE_File_URL = "http://192.168.1.112:8082/gateway/finance/File"
const header = { Authorization: "Bearer " + sessionStorage.getItem("Token") };

class UploadFileService {
  uploadFileBill(data) {
    return api.post(UtilsUrl.fileURL() + "/uploadBill", data);
  }
  uploadFileImage(data) {
    return api.post(UtilsUrl.fileURL() + "/uploadImage", data);
  }

  addFileBill(id, name) {
    return api.get(UtilsUrl.fileURL() + "/addFileBill/" + id + "/" + name);
  }

  uploadFileBillSellCertificat(idBillSell, amountRetenu, data) {
    console.log("amountRetenu", amountRetenu);
    return api.post(
      UtilsUrl.fileURL() +
        "/uploadBillSellCertificat/" +
        idBillSell +
        "/" +
        amountRetenu,
      data
    );
  }
}
export default new UploadFileService();
